// otpService.js
import apiRequest from './handler';

const otpService = {
  /**
   * Requests an OTP to be sent to the specified phone number.
   * @param {string} phoneNumber - The phone number to send the OTP to.
   * @param {string} signInRole - The role of the user signing in.
   * @returns {Promise} - A promise that resolves to the server's response.
   */
  sendOtp: async (phoneNumber, signInRole) => {
    try {
      const response = apiRequest(
        "/common/send-otp",
        "post",
        {
          phone_number: phoneNumber,
          user_type: signInRole,
        },
        false
      )
      return response;
    } catch (error) {
      console.error("Error sending OTP:", error);
      throw error;
    }
  },

  /**
   * Verifies the OTP for the specified phone number.
   * @param {string} phoneNumber - The phone number associated with the OTP.
   * @param {string} otp - The OTP code to verify.
   * @returns {Promise} - A promise that resolves to the server's response.
   */
  verifyOtp: async (phoneNumber, otp, login_role, referredBy, navigate, setIsAuthenticated) => {
    try {
      const response = await apiRequest(
        "/common/login",
        "post",
        {
          login_type: "phone",
          phone_number: phoneNumber,
          otp: otp,
          login_role: login_role,
          referred_by: referredBy,
        },
        false,
        setIsAuthenticated,
        navigate
      )
      return response;
    } catch (error) {
      console.error("Error verifying OTP:", error);
      throw error;
    }
  },

  // The server derives the role from the user's own roles; no role input.
  partnerLogin: async (username, password, navigate, setIsAuthenticated) => {
    try {
      const response = await apiRequest(
        "/common/login",
        "post",
        {
          login_type: "username",
          username: username,
          password: password,
        },
        false,
        setIsAuthenticated,
        navigate
      )
      return response;
    } catch (error) {
      console.error("Error logging in:", error);
      throw error;
    }
  }
};

export default otpService;
